export type TopicState = 'proposed' | 'hidden' | 'live' | 'retired'
export type TopicAction = 'approve' | 'dismiss' | 'show' | 'hide' | 'preview' | 'retire'

export const STATE_LABEL: Record<TopicState, string> = { proposed: 'Proposed', hidden: 'Hidden', live: 'Live', retired: 'Retired' }

export const ACTIONS_BY_STATE: Record<TopicState, TopicAction[]> = {
  proposed: ['approve'],
  hidden: ['show', 'retire'],
  live: ['hide', 'preview', 'retire'],
  retired: [],
}

export const ACTION_LABEL: Record<TopicAction, string> = {
  approve: 'Approve', dismiss: 'Dismiss', show: 'Show to readers', hide: 'Hide', preview: 'Preview', retire: 'Retire',
}

/** The confirm prompt for an action, or null when it acts at once. */
export const CONFIRM: Partial<Record<TopicAction, string>> = {
  show: 'Show this page to readers?',
  hide: 'Hide this page from readers?',
  retire: "Retire this page? It won't come back on its own.",
  dismiss: 'Dismiss this proposal? A page already lives at this address.',
}

/** A proposal whose address is already taken can only be dismissed (approve would 409). */
export function actionsFor(state: string, slugTaken = false): TopicAction[] {
  if (state === 'proposed' && slugTaken) return ['dismiss']
  return ACTIONS_BY_STATE[state as TopicState] ?? []
}

/** Proposal ids and page ids can collide, so the route is chosen by state. */
export function actionPath(state: string, id: number, action: Exclude<TopicAction, 'preview'>): string {
  const base = '/api/editorial/topic-pages'
  return state === 'proposed' ? `${base}/proposals/${id}/${action === 'dismiss' ? 'dismiss' : 'approve'}` : `${base}/${id}/${action}`
}

export const hiddenBanner = (date: string): string => `Hidden from readers since ${date}.`

/** The banner shows when no page is live. */
export function showHiddenBanner(pages: { state: string }[]): boolean {
  return !pages.some((p) => p.state === 'live')
}

export const articleCount = (n: number): string => `${n} ${n === 1 ? 'article' : 'articles'}`
